// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-file-viewer-embedded-adobe-viewer-sdk-wrapper{height:100vh}div[id^=player-interaction-head-file-viewer-pdf-preview-] ::v-deep iframe{pointer-events:auto}", ""]);
// Exports
module.exports = exports;
